// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import {router} from './router'
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import store from './store'
import http from './http'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

// import './custom.scss'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.component("v-select", vSelect);

Vue.config.productionTip = false

Vue.prototype.$http = http

console.log('in main js')
if (localStorage.getItem('user')) {
  let user = JSON.parse(localStorage.getItem('user'))
  let token = user.token
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}
// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  store: store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js